import { CheckSolidIcon, NotApplicableIcon, TimesSolidIcon } from '../../../../../assets/icons';
import { CriteriaResult } from '../../types';

const RESULT_ICONS = {
    'True': CheckSolidIcon,
    'False': TimesSolidIcon,
    'Not Applicable': NotApplicableIcon,
};

interface Props {
    result?: CriteriaResult;
};

/** Tri-state icon used everywhere a recruiting-interview criterion is rendered. */
function ResultIcon({ result }: Props) {
    const Icon = result ? RESULT_ICONS[result] : undefined;
    return Icon ? <Icon /> : null;
};

export default ResultIcon;
